import React from "react";
import { FiPhone,FiMapPin } from "react-icons/fi";
import { CiInstagram } from "react-icons/ci";

function FoodStore() {
  return (
    <main className="main">

      {/* Page Title */}
      <div className="page-title dark-background">
        <div className="container text-center">
          <h1 className="page-heading">MFS – Makkah Food Store</h1>
          <p className="page-subtitle">
            Wholesale & Retail Food Supply Center – Makkah
          </p>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Food Store</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Content Section */}
      <section className="service-details section">
        <div className="container">

          {/* OVERVIEW */}
          <h2>Overview</h2>
          <p>
            Our Food Store Branch in Makkah serves as a reliable destination for
            both wholesale and retail food supplies, catering to customers across
            the Haram boundary and surrounding areas. We offer a wide range of
            essential food items including rice, oils, frozen chicken, soft
            drinks, spices, canned goods, and daily-use groceries sourced from
            trusted suppliers.
          </p>

          {/* BRANCH PROFILE */}
          <h2>Branch Profile</h2>
          <p>
            Our Food Store Branch in Makkah operates as a key supply center for
            high-quality food products, serving both wholesale and retail
            customers. Located within the Haram boundary, the branch provides
            easy access for restaurants, cafeterias, hotels, and households.
          </p>
          <p>
            The branch is organized with proper storage systems, cold-chain
            facilities, and well-maintained stock levels to support uninterrupted
            supply. Our dedicated team ensures fast service, accurate order
            handling, and customer satisfaction for both bulk and daily-use
            purchases.
          </p>

          {/* PRODUCTS */}
          <h2>Products</h2>

          <h3>Rice & Grains</h3>
          <div className="product-row">
            Basmati rice, Sella rice, White rice, Brown rice, Short-grain rice,
            Wheat flour, Maida, Semolina (Rava), Barley, Oats, Lentils (all types),
            Chana dal, Toor dal, Green gram, Red beans, Black beans
          </div>

          <h3>Frozen Items</h3>
          <div className="product-row">
            Frozen chicken (whole, cuts, broast pieces), Frozen beef, Frozen
            mutton, Frozen fish, Nuggets, Fries, Parathas / Chapati, Frozen
            vegetables (peas, sweet corn, mixed veg), Frozen snacks
          </div>

          <h3>Cooking Oils & Fats</h3>
          <div className="product-row">
            Sunflower oil, Corn oil, Palm oil, Olive oil, Coconut oil, Ghee,
            Vanaspati, Butter
          </div>

          <h3>Spices & Masalas</h3>
          <div className="product-row">
            Black pepper, Turmeric, Chilli powder, Coriander powder, Cumin,
            Garam masala, Chicken masala, Fish masala, Curry powder, Mixed spices
          </div>

          <h3>Soft Drinks & Beverages</h3>
          <div className="product-row">
            Water (small & large bottles), Soft drinks, Juices, Energy drinks,
            Milk, Flavoured milk, Laban, Tea powder, Coffee powder, Milk powder
          </div>

          <h3>Canned & Jar Items</h3>
          <div className="product-row">
            Canned tuna, Canned beef, Canned beans, Tomato paste, Pickles,
            Sauces (ketchup, mayonnaise, chilli sauce), Honey, Jams, Olives,
            Vinegar
          </div>

          <h3>Dry Fruits & Nuts</h3>
          <div className="product-row">
            Cashews, Almonds, Pistachios, Raisins, Dates, Walnuts
          </div>

          <h3>Bakery & Dairy</h3>
          <div className="product-row">
            Bread, Buns, Cakes, Fresh milk, Yogurt, Cheese, Cream, Butter milk
          </div>

          <h3>Essential Grocery Items</h3>
          <div className="product-row">
            Sugar, Salt, Tea, Coffee, Pulses, Pasta, Macaroni, Vermicelli,
            Baking powder, Yeast, Rice flour, Corn flour
          </div>

          <h3>Cleaning & Household Items</h3>
          <div className="product-row">
            Dishwashing liquid, Laundry powder, Soap, Shampoo, Sanitizers,
            Tissue rolls, Aluminum foil, Garbage bags, Air fresheners
          </div>

          <h3>Other Daily-Use Items</h3>
          <div className="product-row">
            Eggs, Fresh vegetables, Fresh fruits, Khubz / Roti, Disposable plates,
            Disposable cups, Plastic covers, Drinking straws
          </div>

        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-strip">
        <div className="container">
          <h3 className="contact-heading">Location & Contact</h3>
          <div className="contact-row">
            <span><FiMapPin /> Umm Al-Mu'minin Umm Salamah, Al Kakiyah Dist., 24352 – Makkah, KSA</span>
            <span><FiPhone /> +966 502835483</span>
             <a
                            href="https://www.instagram.com/almac_company?igsh=MThmemIyN2d6aG8zeQ=="
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CiInstagram style={{ fontSize: '28px', color: '#111' }} />

                          </a>
          </div>
        </div>
      </section>

      {/* STYLES */}
      <style>{`
        .page-heading {
          font-size: 3rem;
          font-weight: 800;
          color: #fff;
          margin-bottom: 10px;
        }

        .page-subtitle {
          font-size: 1.2rem;
          color: #e6e6e6;
          margin-bottom: 15px;
        }

        h2 {
          font-size: 2rem;
          margin-top: 35px;
          margin-bottom: 15px;
          color: #222;
        }

        h3 {
          font-size: 1.6rem;
          margin-top: 28px;
          margin-bottom: 12px;
          color: #333;
        }

        p,
        .product-row {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #555;
          margin-bottom: 14px;
        }

        .product-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }

        .contact-strip {
          background: #fafafa;
          border-top: 1px solid #eee;
          margin-top: 60px;
          padding: 45px 0;
        }

        .contact-heading {
          text-align: center;
          font-size: 1.7rem;
          margin-bottom: 25px;
          font-weight: 700;
          color: #222;
        }

        .contact-row {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 25px;
          flex-wrap: wrap;
          font-size: 1rem;
          color: #333;
        }

        .contact-row span {
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 500;
          text-align: center;
        }

        @media (max-width: 576px) {
          .page-heading {
            font-size: 2.2rem;
          }

          h2 {
            font-size: 1.6rem;
          }

          h3 {
            font-size: 1.35rem;
          }

          .product-row {
            flex-direction: column;
            gap: 6px;
          }
        }
      `}</style>

    </main>
  );
}

export default FoodStore;
